import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Experience from './components/Experience';
import MyStory from './components/MyStory';
import StoryDetail from './components/StoryDetail';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Contact from './components/Contact';
import { SiteFooter } from './components/editorial';
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/mystory" element={<MyStory />} />
            <Route path="/mystory/:id" element={<StoryDetail />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <SiteFooter />
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
